<template>
  <div class="containers">
    <common-header
      contentMarginR="11%"
      fontColor="#000"
      content="成绩查询平台"
      backgrounds="#fff"
      :showIcon="true"
    ></common-header>
    <home-banner></home-banner>
    <home-batch-list :batchArr="batchArr"></home-batch-list>
    <div class="bottom" v-if="!isBeike">
      仅显示开放成绩查询的批次，没有找到想要批次，请与报名网站客服联系。
    </div>
  </div>
</template>

<script>
import { onMounted, ref, computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { replaceTime } from "../../js/current";
import { getTestAllBatch } from "../../api/index";
import commonHeader from "../../components/commonHeader.vue";
import HomeBanner from "./components/HomeBanner.vue";
import HomeBatchList from "./components/HomeBatchList.vue";
export default {
  components: { commonHeader, HomeBanner, HomeBatchList },
  name: "Home",
  setup() {
    // const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    // if (isIOS) {
    //   window.history.pushState({}, "title", "#");
    // }
    const route = useRoute();
    const store = useStore();
    // 获取考试code
    const testCode = route.params.id;
    // 存储本次登录的testCode到store
    store.commit("saveTestCode", testCode);
    // 定义批次数组
    let batchArr = ref([]);
    const isBeike = computed(() => {
      return store.getters.isBeike;
    });
    // 获取所有批次
    const getAllBatch = async () => {
      try {
        const { data } = await getTestAllBatch(
          testCode,
          isBeike.value ? store.state.credentialsID : ""
        );
        data.forEach((item) => {
          item.beginTime = replaceTime(item.beginTime);
          item.endTime = replaceTime(item.endTime);
        });
        batchArr.value = data;
      } catch (error) {
        console.log(error);
      }
    };
    onMounted(() => {
      getAllBatch();
    });
    return {
      batchArr,
      isBeike,
    };
  },
};
</script>
<style scoped lang="scss">
@import "scss/color.scss";
.containers {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .bottom {
    bottom: 0;
    position: absolute;
    padding: 24px;
    box-sizing: border-box;
    width: 100%;
    text-align: center;
    color: $color-gray;
    line-height: 40px;
    font-size: 28px;
  }
}
</style>
